import {Pipe, PipeTransform} from '@angular/core';
import {LocalisationService} from '../services/localisation.service';

type TimeObject = {
    hours: number;
    minutes: number;
    seconds: number;
};

@Pipe({
    name: 'minutesToReadableTime'
})

export class MinutesToReadableTimePipe implements PipeTransform {
    constructor(
        private readonly localisationService: LocalisationService
    ) {
    }

    transform(minutes$: string): string {
        const {hours, minutes, seconds} = this.convertTimeObjectToReadableTime(this.convertToTimeObject(this.minutesToMiliseconds(+minutes$)));

        const localisedHours = this.localisationService.localise('hours');
        const localisedHour = this.localisationService.localise('hour');
        const localisedMinutes = this.localisationService.localise('minutes');
        const localisedMinute = this.localisationService.localise('minute');
        const localisedSeconds = this.localisationService.localise('seconds');
        const localisedSecond = this.localisationService.localise('second');
        const and = this.localisationService.localise('and');

        if (hours) {
            if (minutes) {
                return `${hours} ${hours > 1 ? localisedHours : localisedHour} ${and} ${minutes} ${localisedMinutes}`;
            } else {
                return `${hours} ${hours > 1 ? localisedHours : localisedHour}`;
            }
        } else if (minutes) {
            return `${minutes} ${minutes > 1 ? localisedMinutes : localisedMinute}`;
        } else {
            return `${seconds} ${seconds > 1 ? localisedSeconds : localisedSecond}`;
        }
    }

    private minutesToMiliseconds(minutes: number): number {
        return minutes * 60 * 1000;
    }

    private convertToTimeObject(miliseconds: number): TimeObject {
        return {
            hours: miliseconds / 1000 / 3600,
            minutes: miliseconds / 1000 / 60,
            seconds: miliseconds / 1000
        };
    }

    private convertTimeObjectToReadableTime(timeObject: TimeObject): TimeObject {
        return {
            hours: Math.floor(timeObject.hours),
            minutes: Math.floor(timeObject.minutes - Math.floor(timeObject.hours) * 60),
            seconds: Math.floor(timeObject.seconds - Math.floor(timeObject.minutes) * 60),
        };
    }
}

